<template>
  <DragDialog
    class="inner-pop-primary"
    title="任务进度"
    :width="1000"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel">
    <div
      class="minimize-btn-box"
      @click="minimizeConvertQueue">
      <icon-svg
        icon-class="ic-a-ico_Packup"
        size="14"
        class="icon" />
    </div>
    <div
      v-if="isLoading"
      class="loading-box">
      <Spin
        :pointNum="8"
        :translateX="25"
        background="var(--base-primary-bgColor)" />
    </div>
    <div
      class="common-table-box"
      v-else>
      <el-table
        height="100%"
        class="publish-small-table publish-table"
        highlight-selection-row
        :data="queueList">
        <el-table-column
          label="序号"
          type="index"
          width="75" />
        <el-table-column label="任务节点/队列名称">
          <template v-slot="{ row }">
            <div>{{ row.zoneId ? row.zoneId : '--' }}</div>
            <div>{{ row.queueName ? row.queueName : '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="文件名称/文件大小">
          <template v-slot="{ row }">
            <div
              class="text-overflow"
              :title="row.dataSetName">
              {{ row.dataSetName }}
            </div>
            <div class="text-overflow">
              {{
                `${formatFileSize(row.fileTotalSize).fileSize}${
                  formatFileSize(row.fileTotalSize).unit
                }`
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="请求时间/状态"
          width="180">
          <template v-slot="{ row }">
            <div>
              <span v-if="row.convertStatus === 1">--</span>
              <span v-if="row.convertStatus === 2">{{ row.startTime }}</span>
            </div>
            <div>
              <span v-if="row.convertStatus === 1">排队中</span>
              <span v-if="row.convertStatus === 2">转换中</span>
              <span v-if="row.convertStatus === 5">停止中</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="进度"
          width="200">
          <template v-slot="{ row }">
            <span v-if="row.convertStatus !== 2">--</span>
            <div
              v-if="row.convertStatus === 2"
              class="common-progress-box">
              <el-progress
                :show-text="false"
                :percentage="row.ratio" />
              <div class="custom-text">
                <div class="text">{{ `${row.ratio}%` }}</div>
                <div class="progress-name-box text-overflow">
                  {{ row.ratioMsg ? row.ratioMsg : '' }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="160">
          <template v-slot="{ row }">
            <div class="common-button-box operation-cell">
              <el-button
                type="text"
                size="small"
                :disabled="row.convertStatus === 2 || row.convertStatus === 5"
                @click="moveQueue(row, true)">
                上移
              </el-button>
              <el-button
                type="text"
                size="small"
                :disabled="row.convertStatus === 2 || row.convertStatus === 5"
                @click="moveQueue(row, false)">
                下移
              </el-button>
              <el-button
                type="text"
                size="small"
                :disabled="row.convertStatus === 5"
                @click="cancelProjectTransform(row)">
                取消
              </el-button>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="common-empty-box">
            <bj-empty
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template slot="description">
                <div class="empty-text">抱歉，没有找到相关内容</div>
              </template>
            </bj-empty>
          </div>
        </template>
      </el-table>
    </div>
  </DragDialog>
</template>

<script>
import Spin from '@/components/Spin.vue'
import DragDialog from '@/components/CustomDragDialog.vue'

import {
  getSceneConvertQueueService,
  getProjectsConvertingProgress,
  moveConvertQueue,
  stopConvertingProject,
  delQueueProject
} from '@/service/interface'

import { formatFileSize } from '@/utils/generalMethods'

export default {
  data() {
    return {
      isLoading: false,

      queueList: []
    }
  },
  props: {
    visible: Boolean,
    closeDialog: Function,
    minimizeConvertQueue: Function,
    updateConvertDataSets: Function
  },
  components: {
    Spin,
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initQueueList()
      } else {
        this.destroyTimer()

        this.queueList = []
      }
    }
  },
  methods: {
    initQueueList() {
      this.isLoading = true

      this.queryQueueList().then(queueList => {
        this.queueList = queueList
        let convertingDataSets = this.queueList.filter(
          el => el.convertStatus === 2
        )

        if (queueList.length) {
          if (!convertingDataSets.length && !this.refreshQueueTimer) {
            this.refreshQueueTimer = setInterval(this.refreshQueueList, 1000)
            this.isLoading = false
            return
          }
        }

        if (this.refreshProgressTimer) {
          clearInterval(this.refreshProgressTimer)
          this.refreshProgressTimer = null
        }
        if (convertingDataSets.length) {
          this.updateConvertProgress(convertingDataSets)

          // prettier-ignore
          this.refreshProgressTimer = setInterval(this.updateConvertProgress, 10000, convertingDataSets);
        }

        this.isLoading = false
      })
    },
    moveQueue(dataSetInfo, moveDirection) {
      let params = {
        dataSetId: dataSetInfo.dataSetId,
        moveDirection
      }
      moveConvertQueue(params).then(response => {
        if (response.isSuccess) {
          this.refreshQueueList().then(() => {
            this.$message.success('移动成功')
          })
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    cancelProjectTransform(dataSetInfo) {
      if (dataSetInfo.convertStatus === 2) {
        let params = {
          dataSetId: dataSetInfo.dataSetId,
          isStart: false
        }
        stopConvertingProject(params).then(response => {
          if (response.isSuccess) {
            if (!this.refreshQueueTimer) {
              this.refreshQueueTimer = setInterval(this.refreshQueueList, 1000)
              this.$message.success('取消成功')
            }
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        let params = {
          dataSetId: dataSetInfo.dataSetId,
          isForce: true
        }
        delQueueProject(params).then(response => {
          if (response.isSuccess) {
            this.refreshQueueList().then(() => {
              this.$message.success('删除成功')
              this.updateConvertDataSets()
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    updateConvertProgress(convertingDataSets) {
      let dataSetIds = convertingDataSets.map(el => el.dataSetId)
      getProjectsConvertingProgress({ dataSetIds }).then(response => {
        if (response.isSuccess) {
          let dataList = response.data
          for (let i = 0; i < dataList.length; i++) {
            let dataInfo = dataList[i]
            if (dataInfo.ratio === -1) {
              this.refreshQueueList()
              break
            }

            let ratio = Math.round(dataInfo.ratio / 100) / 100
            let find = this.queueList.find(
              el => el.dataSetId === dataInfo.dataSetId
            )

            if (ratio === 100) {
              // 延迟查询，防止当前数据集为最后一个数据集时，队列返回的是空的
              setTimeout(this.refreshQueueList, 500)
              break
            } else {
              this.$set(find, 'ratio', ratio)
              this.$set(find, 'ratioMsg', dataInfo.message)
            }
          }
        }
      })
    },
    refreshQueueList() {
      return new Promise(resolve => {
        this.queryQueueList().then(queueList => {
          queueList.forEach(item => {
            let find = this.queueList.find(
              el => el.dataSetId === item.dataSetId
            )
            if (find && find.ratio) {
              item.ratio = find.ratio
              item.ratioMsg = find.ratioMsg
            }
          })
          this.queueList = queueList

          let convertingDataSets = this.queueList.filter(
            el => el.convertStatus === 2
          )
          if (this.refreshProgressTimer) {
            clearInterval(this.refreshProgressTimer)
            this.refreshProgressTimer = null
          }
          if (convertingDataSets.length && !this.refreshProgressTimer) {
            this.updateConvertProgress(convertingDataSets)
            // prettier-ignore
            this.refreshProgressTimer = setInterval(this.updateConvertProgress, 10000, convertingDataSets);
          }
          resolve()
        })
      })
    },
    getConvertedDataSetIds(newVal, oldVal) {
      let dataSetIds = []
      oldVal.forEach(item => {
        let find = newVal.find(el => el.dataSetId === item.dataSetId)
        if (!find) {
          dataSetIds.push(item.dataSetId)
        }
      })
      return dataSetIds
    },
    destroyTimer() {
      if (this.refreshProgressTimer) {
        clearInterval(this.refreshProgressTimer)
        this.refreshProgressTimer = null
      }

      if (this.refreshQueueTimer) {
        clearInterval(this.refreshQueueTimer)
        this.refreshQueueTimer = null
      }
    },
    cancel() {
      this.closeDialog()
    },
    queryQueueList() {
      return new Promise(resolve => {
        let projId = this.$route.params.projId
        getSceneConvertQueueService({ projId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let queueList = this.formatQueueList(data)
            resolve(queueList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    formatQueueList(queueList) {
      let waiting = []
      let converting = []
      queueList.forEach(item => {
        if (item.convertStatus === 2) {
          converting.push(item)
          if (!item.ratio) {
            item.ratio = 0
            item.ratioMsg = ''
          }
        } else {
          waiting.push(item)
        }
        converting.sort((obj1, obj2) => obj1.queueIndex - obj2.queueIndex)
        waiting.sort((obj1, obj2) => obj1.queueIndex - obj2.queueIndex)
      })
      return [...converting, ...waiting]
    },
    formatFileSize
  }
}
</script>

<style lang="less" scoped>
.inner-pop-primary {
  :deep(.dialog-box) {
    position: relative;

    .dialog-primary-header {
      pointer-events: none;

      .icon {
        pointer-events: all;
      }
    }
  }
}
.minimize-btn-box {
  position: absolute;
  display: flex;
  top: 8px;
  right: 50px;
  font-size: 12px;
  color: var(--dialog-header-icon-color);
  z-index: 2;
  padding: 5px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 4px;

  &:hover {
    background: var(--dialog-header-icon-bgColor);
    border-radius: 4px;
  }

  .icon {
    width: 16px;
    height: 16px;
    font-size: 12px;
    text-align: center;
  }
}

.loading-box {
  height: 500px;
}

.common-table-box {
  height: 500px;

  .common-button-box {
    display: flex;
  }

  .common-progress-box {
    display: flex;

    .el-progress {
      width: 80%;
    }

    .custom-text {
      width: 60px;
      line-height: 12px;
      font-size: 12px;
      text-align: center;

      .text {
        color: #73fbfd;
      }

      .progress-name-box {
        position: absolute;
        top: 5px;
        left: 0px;
        width: calc(100% - 50px);
        color: #73fbfd;
      }
    }

    &:hover {
      .custom-text {
        display: block;
      }
    }
  }
}
</style>
